import React, { useState } from "react";
import Button from "@mui/material/Button";
import QuoteModal from "../quoteModal";
import { withLocalizer } from "utilities/withLocalizer";

import "./addQuoteOption.css";

const AddQuoteOption = (props) => {

    const [isShow, setIsShow] = useState(false);
    const { data, isClone, groupTypes } = props;
    const addOption = props.localize("quote-summary-add-option");


    return (
        <div className="information-row grey-color-bg box-sizing row" data-testid="addquoteoption">
            <QuoteModal data={data} isClone={isClone} isShow={isShow} handleModal={() => setIsShow(false)} events={ props.events } groupTypes={groupTypes} />

            <div className="information-text" data-testid="info-text">
                {addOption}
            </div>
            <div className="pull-right information-button" >
                <Button className="pull-right" data-testid="info-btn" variant="contained" onClick={() => setIsShow(true)}>
                    {"+" + props.localize("qma-add-option")}
                </Button>
            </div>
        </div>
    );
};

export default withLocalizer(AddQuoteOption);
